import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/img/logo_sm.png'


const _hoisted_1 = { id: "layoutAuthentication" }
const _hoisted_2 = { id: "layoutAuthentication_content" }
const _hoisted_3 = { class: "container" }
const _hoisted_4 = { class: "row justify-content-center" }
const _hoisted_5 = { class: "col-lg-5" }
const _hoisted_6 = { class: "card shadow-lg border-0 rounded-lg mt-5" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-header",
  style: {"background":"#004542"}
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "text-center mt-3 mb-3" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_0,
      class: "img-fluid",
      alt: "#",
      width: "350",
      height: "55"
    })
  ])
], -1)
const _hoisted_8 = { class: "card-body" }
const _hoisted_9 = { class: "form-floating mb-3" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", { for: "inputEmail" }, "Usuario:", -1)
const _hoisted_11 = { class: "form-floating mb-3" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", { for: "inputPassword" }, "Contraseña:", -1)
const _hoisted_13 = { class: "mt-4 mb-0" }
const _hoisted_14 = { class: "text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("main", null, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _hoisted_7,
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("form", {
                    onSubmit: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.iniciarSesion()), ["prevent"]))
                  }, [
                    _createElementVNode("div", _hoisted_9, [
                      _withDirectives(_createElementVNode("input", {
                        class: "form-control",
                        id: "inputEmail",
                        type: "text",
                        placeholder: "a",
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.user) = $event)),
                        required: ""
                      }, null, 512), [
                        [_vModelText, _ctx.user]
                      ]),
                      _hoisted_10
                    ]),
                    _createElementVNode("div", _hoisted_11, [
                      _withDirectives(_createElementVNode("input", {
                        class: "form-control",
                        id: "inputPassword",
                        type: "password",
                        placeholder: "a",
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.password) = $event)),
                        required: ""
                      }, null, 512), [
                        [_vModelText, _ctx.password]
                      ]),
                      _hoisted_12
                    ]),
                    _createElementVNode("div", _hoisted_13, [
                      _createElementVNode("div", _hoisted_14, [
                        _createVNode(_component_Button, {
                          type: "submit",
                          label: "Iniciar Sesión",
                          severity: "success",
                          icon: "fa fa-right-from-bracket"
                        })
                      ])
                    ])
                  ], 32)
                ])
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}